<template>
  <!-- EnergySubArea -->
  <div class="energysubarea">
    <div class="con">
      <div class="Files-top">
        <div class="ic-left">
          <span>能源区域</span>
        </div>
        <div class="btns">
          <el-button type="primary" @click="add_ed(0)" class="last-el-button"
            >新增顶级菜单</el-button
          >
        </div>
      </div>
      <div class="mytable" style="margin-top:20px">
        <el-table
          id="demo"
          :height="heights"
          stripe
          :data="tableData"
          border
          style="width: 100%"
          row-key="id"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据" />
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="index" label="序号" width="60" align="center">
          </el-table-column>
          <el-table-column label="名称" align="left" min-width="150">
            <template slot-scope="{ row }">
              <el-link
                type="primary"
                :class="{ actived: mainId === row.id }"
                @click="tempclick(row)"
                >{{ row.name }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column label="编码" prop="code" width="400">
          </el-table-column>
          <el-table-column label="操作" align="center" width="510">
            <template #default="{row}">
              <div
                class="btnssss"
                style="display: flex;justify-content: center; align-items: center;"
              >
                <span style="color:#368ED9" @click="edit_ed(row)">编辑</span>
                <span class="line"></span>
                <span style="color:#FF1D1D" @click="delete_fn(row.id)"
                  >删除</span
                >
                <span class="line"></span>
                <div class="more">
                  <span style="color:#999999" @click="moreFlag_fn(row)"
                    >更多</span
                  >
                  <div
                    class="more-dir"
                    v-show="row.id == moreId"
                    @mouseleave="moreId = ''"
                  >
                    <p @click.stop="tempclick(row)">设备列表</p>
                    <p @click.stop="add_ed(row.id)">添加子区域</p>
                    <p @click.stop="editRegion_ed(row)">区域详情</p>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-drawer
        title=""
        :visible.sync="drawer"
        :with-header="false"
        :size="drawerSize"
      >
        <div class="drawer-con">
          <div class="Files-top">
            <div class="ic-left">
              <span>设备列表({{ deviceName }})</span>
            </div>
            <div class="btns"></div>
          </div>
          <div class="dracaozuo" style="display:flex">
            <div class="dratable" style="width:345px;margin-top:20px">
              <el-table
                ref="multipleTable"
                :data="deviceTableData"
                tooltip-effect="dark"
                style="width: 100%"
                :height="heights + 100"
                border
                @selection-change="handleSelectionChange"
              >
                <template slot="empty">
                  <span class="noData">
                    <img src="@/assets/noData.png" alt="暂无数据" />
                    <span class="text">暂无数据</span>
                  </span>
                </template>
                <el-table-column type="selection" width="44" align="center">
                </el-table-column>
                <el-table-column
                  label="设备号"
                  prop="virtualDeviceNo"
                  width="120"
                >
                </el-table-column>
                <el-table-column prop="name" label="设备名称">
                </el-table-column>
              </el-table>
            </div>
            <div class="dra-btns">
              <div class="left-add" @click="saveDevice">
                添加<img src="@/assets/left.png" alt="" />
              </div>
              <div class="del" @click="device_Del">
                移除<img src="@/assets/right.png" alt="" />
              </div>
            </div>
            <div
              class="dratree"
              :style="{ width: '300px', height: `${heights + 150}px` }"
            >
              <div class="search">
                <el-input
                  placeholder="输入关键字进行过滤"
                  v-model="filterText"
                ></el-input>
              </div>
              <el-scrollbar style="height:calc(100% - 40px);width: 100%;">
                <el-tree
                  :data="deviceData"
                  show-checkbox
                  node-key="numNo"
                  :props="defaultProps1"
                  @check="currentChecked"
                  :filter-node-method="filterNode"
                  default-expand-all
                  ref="tree"
                >
                  <span class="custom-tree-node" slot-scope="{ node }">
                    <img
                      src="../../../public/static/image/elTree/1.9.png"
                      v-show="node.data.Content.Category == 'Organization'"
                    />
                    <img
                      src="../../../public/static/image/elTree/2.1.png"
                      v-show="node.data.Content.Category == 'Device'"
                    />
                    <span style="padding-left: 5px;">{{
                      node.data.Content.Name
                    }}</span>
                  </span>
                </el-tree>
              </el-scrollbar>
            </div>
          </div>
        </div>
      </el-drawer>
      <!-- 新增修改菜单 -->
      <el-dialog
        :title="textMapMenu[dialogStatusMenu]"
        :close-on-click-modal="false"
        v-dialogDrag
        :visible.sync="dialogVisibleMenu"
        width="20%"
        center
      >
        <el-form
          :model="tempMenu"
          :rules="rulesMenu"
          ref="tempMenu"
          label-width="120px"
          class="demo-temp"
        >
          <el-form-item label="名称:" prop="name">
            <el-input v-model="tempMenu.name"></el-input>
          </el-form-item>
          <el-form-item label="区域编码:" prop="code">
            <el-input v-model="tempMenu.code"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisibleMenu = false">取 消</el-button>
            <el-button
              type="primary"
              @click="
                dialogStatusMenu === 'edit'
                  ? edit_fn('tempMenu')
                  : add_fn('tempMenu')
              "
              >确 定
            </el-button>
          </span>
        </template>
      </el-dialog>
      <!-- 新增修改区域信息 -->
      <el-dialog
        v-dialogDrag
        :title="textMap[dialogStatus]"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="800px"
        center
      >
        <el-form
          :inline="true"
          :model="temp"
          ref="temp"
          :rules="rules"
          label-width="143px"
          class="demo-temp"
        >
          <el-form-item
            v-for="(item, index) in columns"
            :key="index"
            :label="item.name"
            :prop="item.key"
          >
            <span
              v-if="item.key == 'buildingAppearancePhoto'"
              style="display: flex;flex-direction: column;position: relative;"
              class="beijing"
            >
              <el-input style="opacity: 0;margin-bottom: 54px;"></el-input>
              <el-image
                :src="temp.buildingAppearancePhoto"
                style="width: 100px;margin-right: 15px;position: absolute;"
                @click="cropper_img_status = true"
              >
                <div slot="error" class="image-slot">
                  <i
                    class="el-icon-plus avatar-uploader-icon"
                    @click="cropper_img_status = true"
                  ></i>
                </div>
              </el-image>
            </span>
            <span v-else-if="item.key == 'coordinate'">
              <el-button type="primary" @click="openMap">地图</el-button>
              <el-input
                style="width: 131px;"
                type="text"
                readonly
                v-model="temp[item.key]"
              ></el-input>
            </span>
            <span v-else-if="item.key == 'energyBuildingTypeId'">
              <el-select
                v-model="temp[item.key]"
                clearable
                placeholder="请选择"
                style="width: 205px;"
              >
                <el-option
                  v-for="(item, i) in options"
                  :key="i"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </span>
            <el-input
              v-else
              v-model="temp[item.key]"
              :placeholder="'请输入' + item.name"
              :disabled="item.disabled"
            ></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button
              type="primary"
              @click="
                dialogStatus === 'edit'
                  ? editRegion_fn('temp')
                  : addRegion_fn('temp')
              "
              >确 定
            </el-button>
          </span>
        </template>
      </el-dialog>
      <!-- 详情区域 -->
      <el-dialog
        title="详情"
        v-dialogDrag
        :visible.sync="detail_status"
        width="400"
        center
      >
        <el-form label-width="120px" class="demo-temp">
          <el-form-item style="margin: 0;" label="父id:">
            <span>{{ temp.UpId }}</span>
          </el-form-item>
          <el-form-item style="margin: 0;" label="模块名:">
            <span>{{ temp.name }}</span>
          </el-form-item>
          <el-form-item style="margin: 0;" label="路由地址:">
            <span>{{ temp.code }}</span>
          </el-form-item>
          <el-form-item style="margin: 0;" label="领导:" prop="Leader">
            <span>{{ temp.Leader }}</span>
          </el-form-item>
          <el-form-item style="margin: 0;" label="等级:">
            <span>{{ temp.number }}</span>
          </el-form-item>
          <el-form-item style="margin: 0;" label="实体类型:">
            <span>{{ temp.EntityType }}</span>
          </el-form-item>
          <el-form-item style="margin: 0;" label="整体水平:">
            <span>{{ temp.EntityLevel }}</span>
          </el-form-item>
          <el-form-item style="margin: 0;" label="区域id:">
            <span>{{ temp.AreaId }}</span>
          </el-form-item>
          <el-form-item style="margin: 0;" label="州:">
            <span>{{ temp.State }}</span>
          </el-form-item>
          <el-form-item style="margin: 0;" label="排序:">
            <span>{{ temp.SerialNo }}</span>
          </el-form-item>
          <el-form-item style="margin: 0;" label="级别代码:">
            <span>{{ temp.LevelCode }}</span>
          </el-form-item>
          <el-form-item style="margin: 0;" label="版本号:">
            <span>{{ temp.VersionNum }}</span>
          </el-form-item>
          <el-form-item style="margin: 0;" label="备注:">
            <span>{{ temp.Memo }}</span>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button type="primary" @click="detail_status = false"
              >确 定
            </el-button>
          </span>
        </template>
      </el-dialog>
      <!-- 裁剪图片 -->
      <el-dialog
        v-dialogDrag
        center
        :visible.sync="cropper_img_status"
        width="500px"
        title="上传图片"
      >
        <cropper_img :msg="temp.type" @func="get_img"></cropper_img>
      </el-dialog>

      <!-- 地图 -->
      <el-dialog
        v-dialogDrag
        center
        title="地图(点击地图选择坐标)"
        :visible.sync="mapStatus"
        :close-on-click-modal="false"
      >
        <bmap
          v-if="mapStatus"
          ref="mychild"
          :inputName="mapData"
          @func="getMsgFormSon"
        ></bmap>
        <div slot="footer" class="dialog-footer">
          <el-button @click="mapStatus = false">取消</el-button>
          <el-button type="primary" @click="clickParent">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Pagination from "../../components/module/Pagination"; // 分页
import subareabuild from "./subAreaBuild2"; // 绑定建筑
import bmap from "../../components/module/map/baiduMapSelect"; // 地图
import cropper_img from "../../components/module/city_picker/cropper_img"; // 裁剪图片
import {
  areaFindArea,
  areaSaveArea,
  areaDeleteArea,
  areaSaveDevice,
  areaFindDevice,
  areaDeleteDevice,
  getAreaByAreaId,
} from "../../api/energySubArea";
import { getReadDeviceTree } from "../../api/abbNewApi";
import {
  findAllBuildingType,
  saveEnergyBuildingInfo,
  getTransformerByAreaId,
} from "../../api/buildingApi";
import resourcesStore from "@/cache/resourcesStore.js";
export default {
  components: { Pagination, subareabuild, cropper_img, bmap },
  data() {
    return {
      heights: document.getElementById("app").clientHeight - 255, //屏幕高度 - 导航栏高度
      isSelectFile: false,
      imgUrl: "",
      drawerSize: "800px",
      drawer: false,
      moreId: "",
      loading: false,
      filterText: "",
      jianzhuData: [],
      jianzhu: false,
      searchName: "",
      //以下是区域信息
      temp: {},
      addRegion_id: "",
      dialogVisible: false,
      dialogStatus: "",
      detail_status: false,
      options: [], //建筑类型
      textMap: {
        add: "新增",
        edit: "编辑",
      },
      columns: [
        {
          name: "名称",
          disabled: true,
          key: "name",
          width: 170,
        },
        {
          name: "编号",
          disabled: true,
          key: "code",
        },
        {
          name: "区域外观图",
          disabled: false,
          key: "buildingAppearancePhoto",
          width: 120,
        },
        {
          name: "区域类型",
          disabled: false,
          key: "energyBuildingTypeId",
          width: 120,
        },
        {
          name: "进线来源",
          disabled: false,
          key: "inlineSource",
        },
        {
          name: "进线数量(个)",
          disabled: false,
          key: "inlineQuantity",
        },
        {
          name: "区域面积(m³)",
          disabled: false,
          key: "buildingArea",
        },
        {
          name: "区域人数(人)",
          disabled: false,
          key: "buildingPopulation",
        },
        {
          name: "变压器数量(个)",
          disabled: true,
          key: "transformerQuantity",
          width: 120,
        },
        {
          name: "总容量(KVA)",
          disabled: true,
          key: "totalCapacityKVA",
          width: 120,
        },
        {
          name: "监测点数(个)",
          disabled: false,
          key: "monitorPoints",
        },
        {
          name: "电房数量(个)",
          disabled: false,
          key: "electricRoomQuantity",
        },
        {
          name: "负荷容量(KVA)",
          disabled: false,
          key: "burdenCapacity",
        },

        {
          name: "年度计划用电(kwh)",
          disabled: false,
          key: "annualPlanUsePower",
          width: 165,
        },
        {
          name: "坐标",
          disabled: false,
          key: "coordinate",
          width: 165,
        },
        {
          name: "年度计划用水(t)",
          disabled: false,
          key: "annualPlanUseWater",
        },
        {
          name: "年度计划用气(m³)",
          disabled: false,
          key: "annualPlanUseGas",
        },
        {
          name: "区域面积指标(m³)",
          disabled: false,
          key: "buildingAreaIndicator",
        },
        {
          name: "区域人数指标(人)",
          disabled: false,
          key: "buildingPopulationIndicator",
        },
        {
          name: "备注",
          disabled: false,
          key: "memo",
        },
      ],
      rules: {
        name: [{ required: true, message: "请输入区域名", trigger: "blur" }],
        code: [{ required: true, message: "请输入区域代码", trigger: "blur" }],
        annualPlanUsePower: [
          { required: true, message: "请输入年度用电", trigger: "blur" },
        ],
        annualPlanUseWater: [
          { required: true, message: "请输入年度计划用水", trigger: "blur" },
        ],
        annualPlanUseGas: [
          { required: true, message: "请输入年度计划用气", trigger: "blur" },
        ],
        buildingAreaIndicator: [
          { required: true, message: "请输入区域面积指标", trigger: "blur" },
        ],
        buildingPopulation: [
          { required: true, message: "请输入区域人数", trigger: "blur" },
        ],
        buildingPopulationIndicator: [
          { required: true, message: "请输入区域人数指标", trigger: "blur" },
        ],
        buildingArea: [
          { required: true, message: "请输入区域面积", trigger: "blur" },
        ],
      },
      mapData: "",
      mapStatus: false,
      cropper_img_status: false,
      img: "",
      //以上是区域信息
      toggleRowData: [],
      bumen: false,
      deviceData: [], //设备树形结构
      data: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      defaultProps1: {
        children: "ChildDatas",
        label: "Content.Name",
      },
      total: 0,
      list: "",
      imageUrl: "",
      // routerUrl: this.$store.state.settings.routerUrl,
      routerUrl: "",
      Password: "",
      passwordType: true, //切换密码展示
      tempMenu: {},
      dialogStatusMenu: "",
      textMapMenu: {
        add: "新增",
        edit: "修改",
      },
      tableData: [],
      heights: document.getElementById("app").clientHeight - 200,
      dialogVisibleMenu: false,
      rulesMenu: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],

        code: [{ required: true, message: "请输入编码", trigger: "blur" }],
      },
      topLevel: 0, //判断是否顶级
      Conditions: {},
      options: [],
      listData: {
        Page: 1,
        Rows: 10,
      },

      mainId: "",
      columnsMenu: [
        {
          name: "区域编码",
          key: "code",
          width: 200,
        },
      ],
      checkedNodes: [],
      deviceName: "",
      deviceTableData: [],
      multipleSelection: [],
      deviceTableDataCopy: [],
      transformerQuantity: 0,
      totalCapacityKVA: 0,
      changData: [],
    };
  },
  mounted() {
    this.getList(); //获取列表数据
    //获取设备树
    var num = 0;
    this.options = [
      {
        createTime: 1693203723000,
        id: "527d9b583c4d4b7fb135969ac093022c",
        code: "DataCenter",
        name: "数据中心机房",
        entityName: "EnergyBuildingType",
      },
      {
        createTime: 1673487139000,
        id: "6954e58347384718a2a1664ca29d5def",
        code: "003",
        name: "工业区",
        entityName: "EnergyBuildingType",
      },
      {
        createTime: 1673407623000,
        id: "ca394d56ae6644f39bb683e8fad133ee",
        code: "001",
        name: "科技园",
        entityName: "EnergyBuildingType",
      },
      {
        createTime: 1680501680000,
        id: "f7099b93a3e946638dbbd916f009472d",
        code: "002",
        name: "园区",
        entityName: "EnergyBuildingType",
      },
      {
        createTime: 1693301049000,
        id: "fbd8e6062d3643fdae45d3da8cf64bf1",
        code: "Heating",
        name: "供暖",
        entityName: "EnergyBuildingType",
      },
    ];
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    searchName(val) {
      if (val == "") {
        this.deviceTableData = this.deviceTableDataCopy;
      }
    },
    unitId() {
      this.getList();
    },
  },

  computed: {
    getResourcesByName() {
      return resourcesStore.getters.getResourcesByName;
    },
    num: function() {
      if (this.bumen && this.jianzhu) {
        return 12;
      } else if (this.bumen || this.jianzhu) {
        return 18;
      } else {
        return 24;
      }
    },
    unitId() {
      return this.$store.unitStore.state.nowUnit;
    },
  },
  methods: {
    moreFlag_fn(row) {
      this.moreId = row.id;
    },
    //输入关键字进行过滤
    filterNode(value, data) {
      if (!value) return true;
      return data.Content.Name.indexOf(value) !== -1;
    },
    //获取子组件数据
    getMsgFormSon(data) {
      if (data.lat) {
        this.$set(this.temp, "coordinate", data.lng + "," + data.lat);
      }
      this.mapStatus = false;
    },
    //调用子组件方法
    clickParent() {
      this.$refs.mychild.sendMsg();
    },
    // 打开地图
    openMap() {
      this.mapData = this.temp.coordinate;
      this.mapStatus = true;
    },
    // 获取裁剪好的图片
    get_img(v) {
      this.$set(this.temp, "buildingAppearancePhoto", v);
      this.cropper_img_status = false;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handlePreview(file) {
      //上传图片
      let formData = new FormData();

      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return;
      }

      this.$set(
        this.temp,
        "buildingAppearancePhoto",
        window.URL.createObjectURL(file.raw)
      );
    },
    //添加区域信息
    addRegion_ed(item) {
      this.dialogStatus = "add";
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs["temp"].clearValidate();
      });
      this.addRegion_id = item;
      // console.log(item);
      this.temp = {};
      this.temp.name = this.addRegion_id.name;
      this.temp.code = this.addRegion_id.code;
    },
    //确定添加区域信息
    addRegion_fn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.temp.areaId = this.addRegion_id.id;
          saveEnergyBuildingInfo(this.temp).then((res) => {
            // console.log("res添加",res);
            if (res && res.code == 200) {
              // this.getList();
              this.dialogVisible = false;
              this.$message({
                showClose: true,
                message: "添加成功",
                type: "success",
              });
              // var bool = this.$store.unitStore.state.buildingNum
              // this.$store.unitStore.commit('setBuildingNum',!bool);
            } else {
              this.$message.error("添加失败");
            }
          });
        } else {
          return false;
        }
      });
    },
    //编辑区域信息
    editRegion_ed(item) {
      console.log(item);
      this.transformerQuantity = 0;
      this.totalCapacityKVA = 0;
      getTransformerByAreaId({ areaId: item.id }).then((res) => {
        if (res.code == 200) {
          this.transformerQuantity = res.data.transformerNum;
          this.totalCapacityKVA = res.data.transformerCapacity;
        }
        getAreaByAreaId({ areaId: item.id }).then((res) => {
          if (res.code == 200) {
            //如果没有是null说明没绑定
            if (res.data == null) {
              // this.$message({type: 'warning',message: '该区域暂未绑定区域信息'});
              this.dialogStatus = "add";
              this.dialogVisible = true;
              this.$nextTick(() => {
                this.$refs["temp"].clearValidate();
              });
              this.addRegion_id = item;
              // console.log(item);
              this.temp = {};
              this.temp.name = this.addRegion_id.name;
              this.temp.code = this.addRegion_id.code;
              this.temp.transformerQuantity = this.transformerQuantity;
              this.temp.totalCapacityKVA = this.totalCapacityKVA;
            } else {
              //有数据代表已经绑定
              this.dialogStatus = "edit";
              this.dialogVisible = true;
              this.temp = Object.assign({}, res.data);
              this.temp.transformerQuantity = this.transformerQuantity;
              this.temp.totalCapacityKVA = this.totalCapacityKVA;
              this.$nextTick(() => {
                this.$refs["temp"].clearValidate();
              });
            }
          }
        });
      });
    },
    // 确认区域编辑
    editRegion_fn() {
      this.$refs["temp"].validate((valid) => {
        if (valid) {
          saveEnergyBuildingInfo(this.temp).then((res) => {
            if (res.code == 200) {
              this.dialogVisible = false;

              this.$message({
                showClose: true,
                message: "修改成功",
                type: "success",
              });
            } else {
              this.$message.error("修改失败");
            }
          });
        } else {
          return false;
        }
      });
    },
    //弹出绑定设备
    tempclick(v) {
      this.mainId = v.id;
      this.deviceName = v.name;
      this.drawer = true;
      this.getDevice();
    },
    //树形结构选中节点
    currentChecked(nodeObj, SelectedObj) {
      this.checkedNodes = SelectedObj.checkedNodes;
      this.checkedNodes = this.checkedNodes.filter(
        (item) => item.Content.Category == "Device"
      );
    },
    // 绑定设备
    saveDevice() {
      if (this.deviceName == "") {
        this.$message({ type: "warning", message: "请选择区域" });
        return;
      }
      if (this.checkedNodes.length == 0) {
        this.$message({ type: "warning", message: "请勾选设备" });
        return;
      }
      var ids = "";
      this.checkedNodes.forEach((item) => (ids += "," + item.Id));
      // console.log(ids.split(1));
      ids = ids.slice(1);
      var d = {
        areaId: this.mainId,
        nos: ids,
      };

      areaSaveDevice(d).then((res) => {
        if (res.code == 200) {
          this.deviceChang();
          this.$message({ type: "success", message: "绑定成功" });
          this.$refs.tree.setCheckedKeys([]);
          this.getDeviceList(this.mainId);
        } else {
          this.$message({ type: "error", message: `绑定失败,${res.message}` });
        }
      });
    },
    //设备绑定移除变化
    deviceChang() {
      getAreaByAreaId({ areaId: this.mainId }).then((res) => {
        if (res.data != null) {
          this.changData = res.data;
          getTransformerByAreaId({ areaId: this.mainId }).then((respon) => {
            if (respon.code == 200) {
              this.changData.transformerQuantity = respon.data.transformerNum;
              this.changData.totalCapacityKVA = respon.data.transformerCapacity;

              saveEnergyBuildingInfo(this.changData).then((res) => {});
            }
          });
        }
      });
    },

    //表格全选反选
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //移除区域的关联设备
    device_Del() {
      if (this.deviceName == "") {
        this.$message({ type: "warning", message: "请选择区域" });
        return;
      }
      // console.log("this.multipleSelection",this.multipleSelection);
      if (this.multipleSelection.length == 0) {
        this.$message({ type: "warning", message: "请勾选需要删除的设备!" });
        return;
      }
      var ids = "";
      this.multipleSelection.forEach(
        (item) => (ids += "," + item.virtualDeviceNo)
      );
      // console.log(ids.split(1));
      ids = ids.slice(1);
      var d = {
        areaId: this.mainId,
        nos: ids,
      };

      areaDeleteDevice(d).then((res) => {
        if (res.code == 200) {
          this.deviceChang();
          this.$message({ type: "success", message: "移除成功!" });
          this.getDeviceList(this.mainId);
        } else {
          this.$message({ type: "error", message: `移除失败,${res.message}` });
        }
      });
    },
    //获取设备列表
    getDeviceList(id) {
      areaFindDevice({ areaId: id }).then((res) => {
        //  console.log("能流图列表",res);
        if (res.code == 200) {
          this.deviceTableData = res.data;
          this.deviceTableDataCopy = res.data;
          var a = this.deviceData;
          var recursiveFunction = function() {
            const getStr = function(list) {
              list.forEach(function(row) {
                if (row.ChildDatas.length != 0) {
                  // console.log("row.ChildDatas",row);
                  getStr(row.ChildDatas);
                } else {
                  row.disabled = false;
                  res.data.forEach((item) => {
                    if (row.Content.Id == item.virtualDeviceNo) {
                      row.disabled = true;
                    }
                  });
                }
              });
            };
            getStr(a);
          };
          recursiveFunction();
          // console.log("rightData",this.rightData.filter(item => item.Id == '1'));
        } else {
          this.$message({ type: "warning", message: "获取失败" });
        }
      });
    },
    //获取区域设备树
    getDevice() {
      this.jianzhu = true;
      this.bumen = true;
      this.getDeviceList(this.mainId);
    },
    //搜索设备列表
    search_fn() {
      this.deviceTableData = this.deviceTableDataCopy.filter((item) =>
        item.name.includes(this.searchName)
      );
    },

    // 删除能源区域
    delete_fn(v) {
      // console.log(v);

      this.$confirm("是否删除此条内容", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          areaDeleteArea({ id: v }).then((data) => {
            if (data.code == 200) {
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success",
              });
              this.getList();
              var flag = this.$store.unitStore.state.buildingNum;
              this.$store.unitStore.commit("setBuildingNum", !flag);
            } else {
              this.$message({
                showClose: true,
                message: data.message,
              });
            }
          });
        })
        .catch(() => {
          // ...
        });
    },
    // 确认添加菜单
    add_fn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var d = {
            code: this.tempMenu.code,
            name: this.tempMenu.name,
            uid: "",
            upId: this.topLevel,
            unitId: this.unitId.id,
          };

          areaSaveArea(d).then((data) => {
            // console.log("添加顶级菜单",data);
            if (data.code == 200) {
              this.getList();
              this.dialogVisibleMenu = false;
              this.$message({
                showClose: true,
                message: "添加成功",
                type: "success",
              });
              var flag = this.$store.unitStore.state.buildingNum;
              this.$store.unitStore.commit("setBuildingNum", !flag);
            } else {
              this.$message.error(`添加失败，${data.message}`);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 添加菜单弹窗
    add_ed(v) {
      this.dialogStatusMenu = "add";
      this.dialogVisibleMenu = true;
      this.topLevel = v;
      // console.log(v);
      this.$nextTick(() => {
        this.$refs["tempMenu"].clearValidate();
      });
      this.tempMenu = { UpId: v || null };
    },
    // 确认菜单编辑
    edit_fn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //  console.log(this.tempMenu);
          // delete this.tempMenu.children;
          var d = {
            code: this.tempMenu.code,
            name: this.tempMenu.name,
            uid: this.tempMenu.id,
            upId: this.tempMenu.upId,
          };
          areaSaveArea(d).then((data) => {
            if (data.code == 200) {
              this.getList();
              this.dialogVisibleMenu = false;
              this.$message({
                showClose: true,
                message: "修改成功",
                type: "success",
              });
              var flag = this.$store.unitStore.state.buildingNum;
              this.$store.unitStore.commit("setBuildingNum", !flag);
            } else {
              this.$message.error(`修改失败，${data.message}`);
            }
          });
        } else {
          return false;
        }
      });
    },
    //编辑菜单弹窗
    edit_ed(v) {
      this.dialogStatusMenu = "edit";
      this.tempMenu = Object.assign({}, v);
      this.dialogVisibleMenu = true;
      this.$nextTick(() => {
        this.$refs["tempMenu"].clearValidate();
      });
    },
    //获取列表数据
    getList() {
      var res = {
        code: 200,
        message: "操作成功",
        data: {
          id: "B5A693FA77804BC8BE009D57D0E7A788",
          unitNo: 40,
          parentId: null,
          unitCode: "",
          name: getName(),
          fullName: getName(),
          energyAreaVos: [
            {
              id: "a8f46feae1ce4a488228271cdaa7fc0c",
              code: "001",
              name: "一号区域",
              upId: "0",
              unitId: "B5A693FA77804BC8BE009D57D0E7A788",
              createTime: 1673060388000,
              energyAreaVos: [
                {
                  id: "abf7fd26bda64bcb9bb36309a8673ce8",
                  code: "00103",
                  name: "一号区域3",
                  upId: "a8f46feae1ce4a488228271cdaa7fc0c",
                  unitId: "B5A693FA77804BC8BE009D57D0E7A788",
                  createTime: 1673231830000,
                  energyAreaVos: [],
                },
                {
                  id: "2ed19c7375e34351b7f1c22ef2ec462b",
                  code: "0011",
                  name: "一号区域1",
                  upId: "a8f46feae1ce4a488228271cdaa7fc0c",
                  unitId: "B5A693FA77804BC8BE009D57D0E7A788",
                  createTime: 1673511435000,
                  energyAreaVos: [],
                },
                {
                  id: "67b47037687c42dca31b55adde91306d",
                  code: "DataCenter",
                  name: "数据中心机房",
                  upId: "a8f46feae1ce4a488228271cdaa7fc0c",
                  unitId: "B5A693FA77804BC8BE009D57D0E7A788",
                  createTime: 1693203759000,
                  energyAreaVos: [],
                },
                {
                  id: "25a4837d21e74e108d87e77585381d24",
                  code: "Heating",
                  name: "供暖",
                  upId: "a8f46feae1ce4a488228271cdaa7fc0c",
                  unitId: "B5A693FA77804BC8BE009D57D0E7A788",
                  createTime: 1693301113000,
                  energyAreaVos: [],
                },
              ],
            },
          ],
        },
      };
      var data = JSON.parse(
        JSON.stringify(res.data).replace(/energyAreaVos/g, "children")
      );

      this.tableData = data.children;
    },
  },
};
</script>

<style lang="scss" scoped>
.line {
  margin: 0px 12px;
  display: inline-block;
  width: 1px;
  height: 18px;
  background-color: #e6e6e6;
}

.more {
  position: relative;

  .more-dir {
    z-index: 10;
    position: absolute;
    width: 120px;
    height: 154px;
    top: 12px;
    right: -23px;
    box-sizing: border-box;
    padding-top: 14px;
    background: url(../../assets/unifyImg/more.png) no-repeat;
    background-size: 100% 100%;

    p {
      font-size: 13px;
      color: #999999;
      margin-top: 15px;

      &:hover {
        color: #368ed9;
      }
    }
  }
}

/deep/.el-table .cell {
  overflow: visible;
}

.drawer-con {
  padding: 12px 20px 20px 20px;
}

.dra-btns {
  width: 88px;
  margin: 0px 12px;
  margin-top: 240px;

  .left-add,
  .del {
    width: 88px;
    height: 32px;
    background-color: #368ed9;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
  }

  .del {
    background-color: #ed6547;
    margin-top: 40px;
  }
}

.dratree {
  padding: 20px 12px 12px 12px;
  box-sizing: border-box;
  border-left: 1px solid #ccc;
}

.energysubarea {
  .con {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-color: #fff;
    padding: 12px 20px 20px 20px;
  }

  .paging {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }

  .public-flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/.el-dialog__header {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e6e6e6;

    span {
      color: #67a3ed;
      font-size: 14px;
      font-weight: bold;
    }

    .el-icon-close {
      font-size: 20px !important;
    }
  }
}
</style>
